import React, { useContext } from "react";

type MusicAppState = ReturnType<typeof useInitMusicAppState>

export const MusicAppContext = React.createContext<MusicAppState>({} as MusicAppState);
export const useMusicAppContext = () => useContext(MusicAppContext)

export const useInitMusicAppState = () => {

  const return_val = {
  }

  return return_val;
};